import axios from 'axios';

const envVite =
  (
    typeof import.meta !==
      'undefined' &&
    import.meta.env
  )
    ? import.meta.env
    : {};

// Vue CLI substitutes this expression at build time; browsers have no process global.
let vueApiUrl = '';
try {
  vueApiUrl = process.env.VUE_APP_API_URL || '';
} catch {
  // Vite/browser runtime without a Vue CLI substitution.
}

let baseURL =
  vueApiUrl ||
  envVite.VITE_API_BASE_URL ||
  '';

try {
  const isDevServer =
    typeof window !==
      'undefined' &&
    window.location &&
    window.location.port ===
      '8080';

  if (
    (
      !baseURL ||
      baseURL === '/api'
    ) &&
    isDevServer
  ) {
    baseURL =
      'http://localhost:3001';
  }
} catch {
  // Ambiente sem window.
}

export const publicAxios =
  axios.create({
    baseURL:
      baseURL ||
      '/api',

    withCredentials:
      false
  });
